export default __webpack_public_path__ + "static/media/greenn.1d3e81be.png";